import { useSelector } from 'react-redux'
import Script from 'next/script'

import { getIsFeatureSwitchEnabled } from 'state/feature-switches/selectors'
import { ConsentGroup } from 'constants/consent'
import { STATIC_ASSETS_URL } from 'constants/index'
import useIsConsentGroupEnabled from 'hooks/useIsConsentGroupEnabled'

const SCRIPT_URLS = {
  mymedia: '//vinted-1.leadsmonitor.io/track.js',
  clarity: `${STATIC_ASSETS_URL}/assets/clarity.js`,
}

// TODO: check if this is okay when routing from next as it might not retrigger
const BottomScripts = () => {
  const mymediaTrackingPixel = useSelector(getIsFeatureSwitchEnabled('mymedia_tracking_pixel'))
  const isClarityEnabled = useSelector(getIsFeatureSwitchEnabled('clarity_enabled'))
  const hasConsentedTargeting = useIsConsentGroupEnabled(ConsentGroup.Targeting)

  const renderMymedia = () => {
    if (!hasConsentedTargeting) return null
    if (!mymediaTrackingPixel) return null

    return (
      <>
        <div id="_lm_pix" className="is-visually-hidden u-sticky-bottom" />
        <Script
          id="mymedia-script"
          data-testid="mymedia-script"
          src={SCRIPT_URLS.mymedia}
          strategy="afterInteractive"
        />
      </>
    )
  }

  const renderClarity = () => {
    if (!isClarityEnabled) return null

    return <Script data-testid="clarity-script" src={SCRIPT_URLS.clarity} />
  }

  return (
    <>
      {renderMymedia()}
      {renderClarity()}
    </>
  )
}

export default BottomScripts
